import React from "react";
import { SharedResizing } from "UI/SharedResizingArea3";
import { Wrapper, Content, P } from "./Components";

export default function ErrorMessage({ children }) {
  return (
    <SharedResizing>
      <Wrapper key={1}>
        <Content>
          <h3 style={{ fontWeight: 600 }}>
            <i
              className="far fa-exclamation-circle"
              style={{ marginRight: "6px" }}
            ></i>
            Error
          </h3>
          <P>{children}</P>
          <P></P>
        </Content>
      </Wrapper>
    </SharedResizing>
  );
}
